module.exports = __webpack_public_path__ + "static/media/24-7.b5f00393.png";